import { PassSyncStatusEnum, TicketStatusEnum } from "../../../../../core/types/Tickets"

const getStatusChipStyles = (status: TicketStatusEnum) => {
  const statusStyles = {
    [TicketStatusEnum.PendingData]: {
      backgroundColor: 'rgba(255, 193, 7, 0.16)', // amarelo/laranja claro
      color: 'rgba(255, 152, 0, 1)',              // laranja vibrante (atenção)
    },
    [TicketStatusEnum.Ready]: {
      backgroundColor: 'rgba(76, 175, 80, 0.16)', // verde claro
      color: 'rgba(56, 142, 60, 1)',              // verde escuro (ok/pronto)
    },
    [TicketStatusEnum.Used]: {
      backgroundColor: 'rgba(33, 150, 243, 0.16)', // azul claro
      color: 'rgba(25, 118, 210, 1)',              // azul médio (já usado)
    },
    [TicketStatusEnum.Canceled]: {
      backgroundColor: 'rgba(244, 67, 54, 0.16)',  // vermelho claro
      color: 'rgba(211, 47, 47, 1)',               // vermelho forte (erro/cancelado)
    },
    [TicketStatusEnum.Transferred]: {
      backgroundColor: 'rgba(156, 39, 176, 0.16)', // roxo claro
      color: 'rgba(123, 31, 162, 1)',              // roxo escuro (movimentado/transferido)
    },
    [TicketStatusEnum.Reserved]: {
      backgroundColor: 'rgba(255, 179, 0, 0.16)', // âmbar claro
      color: 'rgba(255, 143, 0, 1)',              // âmbar (aguardando pagamento)
    },
  };

  return statusStyles[status];
};

const getStatusLabel = (status?: TicketStatusEnum) => {
  const statusLabels: Record<TicketStatusEnum, string> = {
    [TicketStatusEnum.PendingData]: 'Aguardando dados',
    [TicketStatusEnum.Ready]: 'Pronto para uso',
    [TicketStatusEnum.Used]: 'Utilizado',
    [TicketStatusEnum.Canceled]: 'Cancelado',
    [TicketStatusEnum.Transferred]: 'Transferido',
    [TicketStatusEnum.Reserved]: 'Aguardando pagamento',
  }

  return statusLabels[status ?? TicketStatusEnum.PendingData]
}

// --- Integração Celetus Pass ---

// Só há sinalização visual quando houve alguma atividade de sync (Sent/Confirmed/Rejected).
// NotSent (padrão, ou evento sem Pass) não exibe chip.
const getPassSyncLabel = (status?: PassSyncStatusEnum): string | null => {
  const labels: Record<PassSyncStatusEnum, string> = {
    [PassSyncStatusEnum.NotSent]: '',
    [PassSyncStatusEnum.Sent]: 'Enviando ao Pass',
    [PassSyncStatusEnum.Confirmed]: 'Integrado ao Pass',
    [PassSyncStatusEnum.Rejected]: 'Rejeitado no Pass',
  }

  if (status === undefined || status === PassSyncStatusEnum.NotSent) return null
  return labels[status]
}

const getPassSyncChipStyles = (status?: PassSyncStatusEnum) => {
  const styles: Record<PassSyncStatusEnum, { backgroundColor: string; color: string }> = {
    [PassSyncStatusEnum.NotSent]: {
      backgroundColor: 'rgba(158, 158, 158, 0.16)', // cinza
      color: 'rgba(97, 97, 97, 1)',
    },
    [PassSyncStatusEnum.Sent]: {
      backgroundColor: 'rgba(255, 179, 0, 0.16)', // âmbar (aguardando confirmação)
      color: 'rgba(255, 143, 0, 1)',
    },
    [PassSyncStatusEnum.Confirmed]: {
      backgroundColor: 'rgba(76, 175, 80, 0.16)', // verde (ok)
      color: 'rgba(56, 142, 60, 1)',
    },
    [PassSyncStatusEnum.Rejected]: {
      backgroundColor: 'rgba(244, 67, 54, 0.16)', // vermelho (erro)
      color: 'rgba(211, 47, 47, 1)',
    },
  }

  return styles[status ?? PassSyncStatusEnum.NotSent]
}

// Ingressos que valem oferecer o reenvio manual ao Pass.
const canResendToPass = (status?: PassSyncStatusEnum): boolean =>
  status === PassSyncStatusEnum.Rejected || status === PassSyncStatusEnum.Sent

const TicketsFunctions = {
  getStatusChipStyles,
  getStatusLabel,
  getPassSyncLabel,
  getPassSyncChipStyles,
  canResendToPass,
}

export default TicketsFunctions